<div fxLayout="row">
    <div [innerHTML]="termsOfService | sanitizeHtml">
    </div>
</div>